import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
`;

export const ListCellWrapper = styled.li`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
